import styled from "styled-components";

export const AreaButtons = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-end;
	gap: 1rem;
	margin: 0 0 1rem auto;
	width: 100%;
	max-width: 400px;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		flex-direction: column-reverse;
		align-items: center;
		max-width: 100%;

		> button {
			width: 100%;
			max-width: 100%;
			margin: 0;
		}
	}
`;
